import { ExecutorType } from '@40seas/entities/common';
import { EnumColor } from '@40seas/frontend/common/providers';

export const executorTypeColorMapping = {
    [ExecutorType.Application]: 'info',
    [ExecutorType.User]: 'info',
    [ExecutorType.System]: 'info',
    [ExecutorType.Event]: 'info',
} as { [key in ExecutorType]: EnumColor };
